import React from 'react';
import { MessageCircleIcon, MessageSquareIcon } from 'lucide-react';
import { CONTACT } from '../data/site';
export function StickyContactBar() {
  return <>
      {/* Mobile: always-visible sticky bar */}
      <div className="fixed bottom-0 inset-x-0 z-50 border-t border-ink-line bg-black/95 backdrop-blur sm:hidden" data-id="element-239" data-mp="4fzn8wwpdwb">
        <div className="grid grid-cols-2 gap-2 p-2" data-id="element-240" data-mp="3rghgcd5e8a1t">
          <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#25D366] px-4 py-3 text-sm font-bold text-black" data-id="element-241" data-mp="93t41n66bca6">
            <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-242" data-mp="j1h9b71eo26l" />
            WhatsApp
          </a>
          <a href={CONTACT.sms} className="inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-brand-orange to-brand-red px-4 py-3 text-sm font-bold text-white" data-id="element-243" data-mp="e3xmhiqn6h31">
            <MessageSquareIcon className="h-5 w-5" aria-hidden="true" data-id="element-244" data-mp="3vov2plh21adw" />
            Text Us
          </a>
        </div>
      </div>

      {/* Desktop: floating action buttons */}
      <div className="hidden sm:flex fixed bottom-6 right-6 z-50 flex-col items-end gap-3" data-id="element-245" data-mp="3izlfbr0aymp">
        <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-bold text-black shadow-xl shadow-black/40 transition-transform hover:scale-[1.04]" data-id="element-246" data-mp="8iucbfas7o7r">
          <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-247" data-mp="n78bng8zoujk" />
          WhatsApp
        </a>
        <a href={CONTACT.sms} className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-brand-orange to-brand-red px-5 py-3 text-sm font-bold text-white shadow-xl shadow-brand-red/30 transition-transform hover:scale-[1.04]" data-id="element-248" data-mp="rbg2pk2x6mky">
          <MessageSquareIcon className="h-5 w-5" aria-hidden="true" data-id="element-249" data-mp="2y25rcl0gplfd" />
          Text {CONTACT.phoneDisplay}
        </a>
      </div>
    </>;
}